import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import {
	IonButton,
	IonCard,
	IonCardContent,
	IonContent,
	IonHeader,
	IonIcon,
	IonTitle,
	IonToolbar
} from '@ionic/angular';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
	selector: 'app-nova-portal-not-found-page',
	templateUrl: './not-found.page.html',
	styleUrls: ['./not-found.page.scss'],
	imports: [
		IonButton,
		IonCard,
		IonCardContent,
		IonContent,
		IonHeader,
		IonIcon,
		IonTitle,
		IonToolbar,
		RouterLink,
		TranslateDirective,
		TranslatePipe
	]
})
export class NotFoundPage implements OnInit {
	public titleKey?: string;
	public messageKey?: string;
	public link?: string;

	private router = inject(Router);

	public ngOnInit(): void {
		this.titleKey = this.titleKey ?? (this.router.currentNavigation()?.extras?.state?.['titleKey'] as string);
		this.messageKey = this.messageKey ?? (this.router.currentNavigation()?.extras?.state?.['messageKey'] as string);
		this.link = this.link ?? (this.router.currentNavigation()?.extras?.state?.['link'] as string);
	}
}
